import Session from "../auth/Session";

const AccountFunctions = {
    getAccountAsync: async function (name) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/GetAccount`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getAccountsAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/Account/GetAccounts`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getAccountById: async function (id) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/GetAccountByIdAsync`, {
            method: "POST",
            body: JSON.stringify({ "id" : id }),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getInvoicesAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/Account/GetInvoices`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getInvoiceAsync: async function (invoiceNo) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/GetInvoice?invoiceNo=${invoiceNo}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    postAccountUploadAsync: async function (fileData) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/UploadAccountFile`, {
            method: "POST",
            body: fileData,
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    postAccountCreditCardAsync: async function (fileData) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/AccountCreditCard`, {
            method: "POST",
            body: fileData,
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    postAccountUpdateAsync: async function (accountData) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/RequestAccountUpdate`, {
            method: "POST",
            body: JSON.stringify(accountData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },
    postCustomerSupportRequestAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/Account/CustomerSupportRequest`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        return data;
    },

}

export default AccountFunctions;